export default "__VITE_ASSET__CxbN9CtX__"